import { CHECKOUT_SLOT_TYPE } from 'types'
import fieldNameFromTitle from './fieldNameFromTitle'

const defaultCheckOutForm = { fields: [] }

// The check-out form arrives as an ordered list of fields. Slot markers pass through
// untouched; every data field is guaranteed a Formik `fieldName` -- the internal state /
// validation / submit-routing key, NOT the human-readable label (that is `title`, which is
// left alone and may repeat freely):
//   * question fields are always keyed by their unique question id, never an API-supplied
//     `fieldName`, so a custom question whose title happens to be "Notes" cannot collide
//     with the core `notes` trip field in form state or the submit split;
//   * core data fields keep the name the API sends (`status`, `notes`, the photo buckets),
//     because the submit path routes trip attributes on exactly those names;
//   * anything else falls back to a name derived from its title.
export default function decorateCheckOutFormWithFieldNames(checkOutForm) {
  const form = checkOutForm || defaultCheckOutForm
  const fields = (form.fields || []).map((field) => {
    if (field.type === CHECKOUT_SLOT_TYPE) return field
    if (field.questionId)
      return { ...field, fieldName: `question_${field.questionId}` }
    if (field.fieldName) return field

    return { ...field, fieldName: fieldNameFromTitle(field.title) }
  })

  return { ...form, fields }
}
